import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Home } from 'lucide-react';

const Navigation = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);

  const navItems = [
    { name: 'Home', path: '/', icon: true },
    { 
      name: 'About Us', 
      dropdown: [
        { 
          heading: 'About',
          items: [
            { name: 'About DAVCMC', link: 'https://customer-assets.emergentagent.com/job_solapur-shop-preview/artifacts/qqaaveor_DAV-College-Managing-Committee.pdf', external: true },
            { name: 'About College', link: '/about-college', external: false }
          ]
        }
      ]
    },
    { 
      name: 'Academics', 
      dropdown: [
        { 
          heading: 'Programmes Offered',
          items: [
            { name: 'Undergraduate Programmes', link: '/course.php?cid=UG', external: false },
            { name: 'Post Graduate Programmes', link: '/course.php?cid=PG', external: false },
            { name: 'Research Programme', link: '/course.php?cid=PHD', external: false },
            { name: 'Programme Self Declaration', link: 'https://www.davcommercesolapur.org/DAV/selfdeclaration.pdf', external: true }
          ]
        },
        { 
          heading: 'Academic Calendar',
          items: [
            { name: '2018-19', link: 'https://www.davcommercesolapur.org/DAV/Calander 18-19 pdf.pdf', external: true },
            { name: '2019-20', link: 'https://www.davcommercesolapur.org/DAV/calendar_19-20.pdf', external: true },
            { name: '2020-21', link: 'https://www.davcommercesolapur.org/DAV/calendar_19-20.pdf', external: true },
            { name: '2021-22', link: 'https://www.davcommercesolapur.org/DAV/3_Academic_Calendar_2021 22.pdf', external: true },
            { name: '2022-23', link: 'https://www.davcommercesolapur.org/DAV/Academic Calender 2022-23.pdf', external: true }
          ]
        },
        { 
          heading: 'Attributes Defined',
          items: [
            { name: 'Graduate Attributes', link: 'https://www.davcommercesolapur.org/DAV/Graduate Attributes.pdf', external: true }
          ]
        }
      ]
    },
    { 
      name: 'Departments', 
      dropdown: [
        { 
          heading: 'Departments',
          items: [
            { name: 'Department of Commerce', link: '#', external: false },
            { name: 'Department of Accountancy', link: '#', external: false },
            { name: 'Department of Computer Science', link: '#', external: false },
            { name: 'Department of Physical Education and Sports', link: '/sports.php', external: false }
          ]
        }
      ]
    },
    { name: 'Faculty', path: '/faculty.php' },
    { 
      name: 'NAAC/IQAC',
      dropdown: [
        { 
          heading: 'Reaccreditation Certificate',
          items: [
            { name: 'SSR 2015', link: 'https://www.davcommercesolapur.org/DAV/Final RAR pdf.pdf', external: true }
          ]
        },
        { 
          heading: 'IQAC Meetings and ATR',
          items: [
            { name: 'IQAC 2015-2016', link: 'https://www.davcommercesolapur.org/DAV/iqac_15_16.pdf', external: true },
            { name: 'IQAC 2016-2017', link: 'https://www.davcommercesolapur.org/DAV/iqac_16_17.pdf', external: true },
            { name: 'IQAC 2017-2018', link: 'https://www.davcommercesolapur.org/DAV/iqac_17_18.pdf', external: true },
            { name: 'IQAC 2018-2019', link: 'https://www.davcommercesolapur.org/DAV/iqac_18_19.pdf', external: true },
            { name: 'IQAC 2019-2020', link: 'https://www.davcommercesolapur.org/DAV/CamScanner 12-30-2021 11.21.43.pdf', external: true },
            { name: 'IQAC 2020-2021', link: 'https://www.davcommercesolapur.org/DAV/IQAC Minutes_20_21.pdf', external: true },
            { name: 'IQAC 2021-22', link: 'https://www.davcommercesolapur.org/DAV/4_IQAC_Minutes_2021-22.pdf', external: true },
            { name: 'IQAC 2022-23', link: 'https://www.davcommercesolapur.org/DAV/IQAC MEETINGS.pdf', external: true },
            { name: 'IQAC 2023-2024', link: 'https://data.davcommercesolapur.com/IQAC-meetings-2023-24.pdf', external: true }
          ]
        },
        { 
          heading: 'AQAR Reports',
          items: [
            { name: '2015-2016', link: 'https://www.davcommercesolapur.org/DAV/AQAR 2015-16.pdf', external: true },
            { name: '2016-2017', link: 'https://www.davcommercesolapur.org/DAV/AQAR 2016-17.pdf', external: true },
            { name: '2017-2018', link: 'https://www.davcommercesolapur.org/DAV/AQAR 2017-18.pdf', external: true },
            { name: '2018-2019', link: 'https://data.davcommercesolapur.com/AQAR-2018-19.pdf', external: true },
            { name: '2019-2020', link: 'https://data.davcommercesolapur.com/AQAR-2019-20.pdf', external: true },
            { name: '2020-2021', link: 'https://data.davcommercesolapur.com/AQAR-2020-21.pdf', external: true },
            { name: '2021-2022', link: 'https://data.davcommercesolapur.com/AQAR-2021-22.pdf', external: true },
            { name: '2022-2023', link: 'https://data.davcommercesolapur.com/AQAR-2022-23.pdf', external: true },
            { name: '2023-2024', link: 'https://data.davcommercesolapur.com/AQAR-2023-24.html', external: true }
          ]
        }
      ]
    },
    { 
      name: 'NIRF',
      dropdown: [
        { 
          heading: 'NIRF Reports',
          items: [
            { name: '2016-17', link: 'https://www.davcommercesolapur.org/DAV/nirf 2017.pdf', external: true },
            { name: '2017-18', link: 'https://www.davcommercesolapur.org/DAV/nirf 2017.pdf', external: true },
            { name: '2018-19', link: 'https://www.davcommercesolapur.org/DAV/nirf 2019.pdf', external: true },
            { name: '2019-20', link: 'https://www.davcommercesolapur.org/DAV/nirf 2020.pdf', external: true }
          ]
        }
      ]
    },
    { 
      name: 'Student Devp. Schemes', 
      dropdown: [
        { 
          heading: 'Student Development',
          items: [
            { name: 'Students\' Grievance Cell', link: '#', external: false },
            { name: 'Anti Raging Committee', link: '#', external: false },
            { name: 'Scholarships', link: '#', external: false },
            { name: 'Placement', link: '#', external: false },
            { name: 'Mentoring and Counseling', link: '#', external: false },
            { name: 'Student Welfare', link: '#', external: false },
            { name: 'NCC', link: '#', external: false },
            { name: 'NSS', link: '/nss', external: false },
            { name: 'Education & Sports', link: '#', external: false },
            { name: 'BC Cells', link: '#', external: false },
            { name: 'Student Insurance', link: '#', external: false },
            { name: 'Student Councile', link: '#', external: false },
            { name: 'Rules and Information Handbook', link: '#', external: false }
          ]
        },
        { 
          heading: 'Registration for Admissions',
          items: [
            { name: 'Registration For B.Com-I', link: 'https://docs.google.com/forms/d/e/1FAIpQLSe-vMPV6vHHF5afF6F0oidbl5yKZFtLC5cq2pU59fAMC4wrbw/viewform?usp=sf_link', external: true },
            { name: 'Registration For B.Com-II', link: 'https://docs.google.com/forms/d/e/1FAIpQLScv_63Fflqk37cR6lTCV68Yjl_tP_T0mnI1gaSAHaBNw44rnQ/viewform?usp=sf_link', external: true },
            { name: 'Registration For B.Com-III', link: 'https://docs.google.com/forms/d/e/1FAIpQLSdZoTJdyxMY7qNfW4W3noxMdZZYHqUeFsm62iY4fOUTn44cCA/viewform?usp=sf_link', external: true },
            { name: 'Institute Level Form BCA', link: 'https://docs.google.com/forms/d/e/1FAIpQLSek5iwt1IE9Ia9MLs4Qce9G5vrdsCC3_pEIcuCnxnuyrGnhRw/viewform', external: true },
            { name: 'Against Vacant Seats Form BCA', link: 'https://forms.gle/swX3ZF81VWhWom7AA', external: true },
            { name: 'Registration For M.Com-II', link: 'https://docs.google.com/forms/d/e/1FAIpQLSdOheqTP_xMK2_kUzSic2Cj2yzs09St-mMbsiKd_fI1mGE3Gw/viewform?usp=sf_link', external: true }
          ]
        },
        { 
          heading: 'Merit List',
          items: [
            { name: 'B.Com - I merit', link: 'https://www.davcommercesolapur.org/DAV/BCOM 2ND.pdf', external: true }
          ]
        }
      ]
    },
    { name: 'Feedback', path: 'https://www.davcommercesolapur.org/DAV/Feedback Website Upload.pdf', external: true },
    { 
      name: 'LMS',
      dropdown: [
        { 
          heading: 'LMS',
          items: [
            { name: 'LMS of Teacher', link: '#', external: false },
            { name: 'Google Classroom', link: '#', external: false },
            { name: 'E-pathshala', link: '#', external: false }
          ]
        }
      ]
    },
    { 
      name: 'E-Resources',
      dropdown: [
        { 
          heading: 'E-Resource',
          items: [
            { name: 'Teacher class Videos', link: '#', external: false },
            { name: 'Teacher PPTs', link: '#', external: false },
            { name: 'Useful Links of websites', link: '#', external: false },
            { name: 'Digital Depository', link: '#', external: false }
          ]
        }
      ]
    },
    { 
      name: 'Research',
      dropdown: [
        { 
          heading: 'Research',
          items: [
            { name: 'College Research Policy', link: '#', external: false },
            { name: 'Research Committee', link: '#', external: false }
          ]
        },
        { 
          heading: 'Research Center',
          items: [
            { name: 'Research Center in Commerce', link: '#', external: false },
            { name: 'Research Center in English', link: '#', external: false }
          ]
        },
        { 
          heading: 'Consultancy',
          items: [
            { name: 'Consultancy areas and policy', link: '#', external: false }
          ]
        },
        { 
          heading: 'DAV Prayas (Incubation)',
          items: [
            { name: 'Incubation and Start up Policy', link: '#', external: false },
            { name: 'Committee', link: '#', external: false },
            { name: 'Projects and Events', link: '#', external: false }
          ]
        }
      ]
    },
    { name: 'Contact Us', path: '/contact' }
  ];

  return (
    <nav className="bg-[#000066] sticky top-0 z-50 shadow-lg">
      <div className="container mx-auto">
        <ul className="flex items-center justify-center flex-wrap text-xs">
          {navItems.map((item, index) => (
            <li
              key={index}
              className="relative group"
              onMouseEnter={() => setActiveDropdown(index)}
              onMouseLeave={() => setActiveDropdown(null)}
            >
              {item.path ? (
                item.external ? (
                  <a
                    href={item.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center px-3 py-3 text-white text-xs font-medium hover:bg-[#0000AA] transition-colors duration-200 whitespace-nowrap"
                  >
                    {item.icon && <Home className="w-4 h-4 mr-1" />}
                    {item.name}
                  </a>
                ) : (
                  <Link
                    to={item.path}
                    className="flex items-center px-3 py-3 text-white text-xs font-medium hover:bg-[#0000AA] transition-colors duration-200 whitespace-nowrap"
                  >
                    {item.icon && <Home className="w-4 h-4 mr-1" />}
                    {item.name}
                  </Link>
                )
              ) : (
                <button className="flex items-center px-3 py-3 text-white text-xs font-medium hover:bg-[#0000AA] transition-colors duration-200 whitespace-nowrap">
                  {item.name}
                  {item.dropdown && <ChevronDown className="w-3 h-3 ml-1" />}
                </button>
              )}
              
              {/* Mega Dropdown Menu */}
              {item.dropdown && activeDropdown === index && (
                <div className="absolute left-0 top-full bg-white shadow-2xl min-w-[600px] py-4 animate-in fade-in slide-in-from-top-2 z-50">
                  <div className="grid grid-cols-3 gap-4 px-4">
                    {item.dropdown.map((section, sectionIndex) => (
                      <div key={sectionIndex}>
                        <h3 className="font-bold text-xs text-gray-800 mb-2 pb-1 border-b border-gray-200">
                          {section.heading}
                        </h3>
                        <ul className="space-y-1">
                          {section.items && section.items.map((subItem, subIndex) => (
                            section.external ? (
                              <li key={subIndex}>
                                <a
                                  href={subItem.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="block px-2 py-1 text-xs text-gray-700 hover:bg-gray-100 hover:text-[#000066] transition-colors rounded"
                                >
                                  {subItem.name}
                                </a>
                              </li>
                            ) : (
                              <li key={subIndex}>
                                <Link
                                  to={subItem.link}
                                  className="block px-2 py-1 text-xs text-gray-700 hover:bg-gray-100 hover:text-[#000066] transition-colors rounded"
                                >
                                  {subItem.name}
                                </Link>
                              </li>
                            )
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;